/* Équilibre only: framed views are independent of the original photograph's zoom. */
(() => {
  const source = document.querySelector('[data-equilibre-framed-images]');
  const config = source ? JSON.parse(source.textContent) : {formats: {}};
  let images = [];
  let activeFormat = null;
  let dialog;
  let dialogImage;
  let externalGallery = false;
  let current = 0;
  let returnFocus;
  let previousOverflow;
  let start;
  function applyFrontScale(stage, format, index) {
    const data = config.formats[format];
    const front = config.reference === 'A13 V2' && index === 0 && data?.frontPresentation;
    stage.classList.toggle('is-front', Boolean(front));
    if (!front) return;
    const [x, y, width, height] = front.boundsPx;
    stage.style.setProperty('--frame-width', `${data.frameCm[0]}%`);
    stage.style.setProperty('--frame-ratio', `${width} / ${height}`);
    stage.style.setProperty('--source-width', `${front.sourcePx[0] / width * 100}%`);
    stage.style.setProperty('--source-left', `${-x / width * 100}%`);
    stage.style.setProperty('--source-top', `${-y / height * 100}%`);
  }
  const update = () => {
    const item = images[current];
    const crop = dialog.querySelector('.equilibre-front-crop');
    if (externalGallery && item.stage) {
      const composition = item.stage.cloneNode(true);
      composition.classList.add('alu-dialog-composition');
      if (item.viewClass) composition.classList.add(item.viewClass);
      crop.replaceChildren(composition);
    } else {
      dialogImage.src = item.src;
      dialogImage.alt = item.alt || item.label;
      crop.replaceChildren(dialogImage);
    }
    dialog.classList.toggle('is-alu-gallery', externalGallery);
    dialog.querySelector('.equilibre-front-stage').classList.toggle('is-front', false);
    if (!externalGallery) applyFrontScale(dialog.querySelector('.equilibre-front-stage'), activeFormat, current);
    dialog.querySelector('.equilibre-framed-close').setAttribute('aria-label', externalGallery ? 'Fermer la galerie Alu Dibond' : 'Fermer la vue encadrée');
    dialog.querySelector('.is-previous').setAttribute('aria-label', externalGallery ? 'Vue Alu Dibond précédente' : 'Vue encadrée précédente');
    dialog.querySelector('.is-next').setAttribute('aria-label', externalGallery ? 'Vue Alu Dibond suivante' : 'Vue encadrée suivante');
    dialog.setAttribute('aria-label', images[current].label);
    dialog.querySelector('.equilibre-framed-counter').textContent = `${current + 1} / ${images.length}`;
  };
  function move(direction) { current = (current + direction + images.length) % images.length; update(); }
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'equilibre-framed-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'equilibre-framed-close';
    close.setAttribute('aria-label', 'Fermer la vue encadrée'); close.textContent = '×';
    close.addEventListener('click', () => dialog.close());
    const image = document.createElement('img');
    image.draggable = false;
    dialogImage = image;
    const stage = document.createElement('div'); stage.className = 'equilibre-front-stage';
    const crop = document.createElement('div'); crop.className = 'equilibre-front-crop';
    crop.append(image); stage.append(crop); dialog.append(close, stage);
    const navigation = document.createElement('div'); navigation.className = 'equilibre-framed-navigation';
    const counter = document.createElement('span'); counter.className = 'equilibre-framed-counter';
    counter.setAttribute('aria-live', 'polite');
    [-1, 1].forEach(direction => {
      const button = document.createElement('button'); button.type = 'button';
      button.className = `equilibre-framed-arrow ${direction < 0 ? 'is-previous' : 'is-next'}`;
      button.setAttribute('aria-label', direction < 0 ? 'Vue encadrée précédente' : 'Vue encadrée suivante');
      button.innerHTML = '<span aria-hidden="true"></span>';
      button.addEventListener('click', () => move(direction)); navigation.append(button);
      if (direction === -1) navigation.append(counter);
    });
    dialog.append(navigation);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      start = null; returnFocus?.focus({preventScroll: true});
    });
    stage.addEventListener('touchstart', event => {
      start = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
    }, {passive: true});
    stage.addEventListener('touchend', event => {
      if (!start || event.changedTouches.length !== 1) return;
      const dx = event.changedTouches[0].clientX - start.x;
      const dy = event.changedTouches[0].clientY - start.y; start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) move(dx < 0 ? 1 : -1);
    }, {passive: true});
    stage.addEventListener('touchcancel', () => { start = null; }, {passive: true});
    document.body.append(dialog);
  }
  window.ROSCOFF_EQUILIBRE_FRAMED = {
    render(grid, format) {
      if (dialog?.open) dialog.close();
      externalGallery = false;
      activeFormat = format;
      images = config.formats[format]?.images || [];
      if (config.reference !== 'A13 V2' && images.length === 4) images = images.slice(1);
      grid.replaceChildren();
      grid.dataset.framedFormat = format;
      grid.dataset.visualStatus = config.formats[format]?.visualStatus || 'missing';
      if (images.length !== (config.reference === 'A13 V2' ? 4 : 3)) return false;
      images.forEach((item, index) => {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'equilibre-framed-preview';
        button.setAttribute('aria-label', `Agrandir : ${item.label}`);
        button.setAttribute('aria-haspopup', 'dialog');
        const image = document.createElement('img');
        image.src = `${item.src}${item.src.includes('?') ? '&' : '?'}width=600`;
        image.alt = item.label;
        image.loading = 'lazy'; image.decoding = 'async'; image.draggable = false;
        if (config.reference === 'A13 V2' && index === 0) {
          const stage = document.createElement('div'); stage.className = 'equilibre-front-stage';
          const crop = document.createElement('div'); crop.className = 'equilibre-front-crop';
          applyFrontScale(stage, format, index);
          crop.append(image); stage.append(crop); button.append(stage);
        } else button.append(image);
        button.addEventListener('click', () => {
          if (activeFormat !== format) return;
          if (!dialog) createDialog();
          current = index; returnFocus = button; update();
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden'; dialog.showModal();
        });
        grid.append(button);
      });
      return true;
    },
    openGallery(items, index, trigger) {
      if (!Array.isArray(items) || !items.length || index < 0 || index >= items.length) return;
      if (dialog?.open) dialog.close();
      externalGallery = true;
      images = items;
      activeFormat = null;
      if (!dialog) createDialog();
      current = index;
      returnFocus = trigger;
      update();
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    },
    close() { if (dialog?.open) dialog.close(); }
  };
})();

